<script setup lang="ts">
const props = defineProps({
  notification: {
    type: Object,
    default: () => {}
  }
})
const { t } = useI18n()
</script>
<template>
  <div>
    <p style="white-space: normal">
      <strong>{{ notification.event_name ?? '' }}: {{ t(notification.message ?? '') }}</strong>
    </p>
    <p v-if="notification.url" class="w-100 whitespace-normal mb-0" style="white-space: normal">
      <a :href="notification.url" class="btn btn-link px-0 py-0" target="_blank">{{ t('Download here') }}</a>
    </p>
  </div>
</template>
